// extracted by mini-css-extract-plugin
module.exports = {"fab":"BackToTop_fab__2BvMZ","visible":"BackToTop_visible__1Kdqr"};